exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb{\r\n  margin-top:10px;\r\n}\r\n.row{\r\n\tmargin-bottom:0px;\r\n}\r\n.well{\r\nbox-shadow:1px 1px 1px 1px #01484f;\r\nheight:30%;\r\nmin-height: 160px;\r\nmin-width:20%;\r\n//max-width:180px;\r\ncursor:pointer;\r\nbackground: #007B85;\r\nmargin-bottom: 50px;\r\nborder:none;\r\n}\r\n.well:hover{\r\n\tbox-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);\r\n}\r\na{\r\n  color:white;\r\n  text-decoration: none;\r\n}\r\ni{\r\n  color:white;\r\n  font-size:10px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = 457
// module chunks = 1